import React from "react";

const TrustBar = ({ t }) => (
  <section className="trust-bar anim-section home-section" id="recursos">
    {/* <div className="home-container trust-grid">
      <div className="trust-item card-animated anim-card">
        <span className="trust-label">{t.trust[0].label}</span>
        <br />
        <strong>{t.trust[0].strong}</strong>
      </div>
      <div className="trust-item card-animated anim-card">
        <span className="trust-label">{t.trust[1].label} </span>
        <strong data-count-target="99.9" data-count-decimals="1">0</strong>
        <span className="trust-sub">{t.trust[1].sub}</span>
      </div>
      <div className="trust-item card-animated anim-card">
        <span className="trust-label">{t.trust[2].label} </span>
        <strong data-count-target="2300000" data-count-prefix="+">0</strong>
        <span className="trust-sub">{t.trust[2].sub}</span>
      </div>
      <div className="trust-item card-animated anim-card">
        <span className="trust-label">{t.trust[3].label} </span>
        <strong data-count-target="45000" data-count-prefix="+">0</strong>
        <span className="trust-sub">{t.trust[3].sub}</span>
      </div>
    </div> */}
    <div className="home-container trust-feature">
      <div className="section-head">
        <h2>{t.trustSection.head}</h2>
        <p>{t.trustSection.sub}</p>
      </div>
      <div className="trust-feature-grid">
        {t.trustSection.cards.map((card) => (
          <article className="trust-feature-card card-animated anim-card" key={card.title}>
            <span className="trust-feature-icon" aria-hidden="true">
              {card.icon}
            </span>
            <h3>{card.title}</h3>
            <p>{card.text}</p>
          </article>
        ))}
      </div>
      <div className="trust-flow">
        {t.trustSection.flow}
      </div>
    </div>
  </section>
);

export default TrustBar;
